import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { getCookie, LoaderComponent } from '@poste-click-connect/shared-ui';
import { FacadeService } from './services/facade.service';
import { InterceptorService } from './services/interceptor.service';

@Component({
  standalone: true,
  imports: [RouterModule, LoaderComponent],
  selector: 'poste-click-connect-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    public interceptor: InterceptorService,
    private facade: FacadeService,
    private router: Router,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('it');
    translate.use('it');
  }

  ngOnInit(): void {
    const token = getCookie('accessToken');
    const user = getCookie('user');

    if (token && user) {
      this.facade.successLogin({
        authToken: token,
        ...(user ? { utente: JSON.parse(user) } : {}),
        responseCambioPassword: null,
      });
    }

    this.facade.retrieveConfig(token);
  }

  navigation(selected: string): void {
    switch (selected) {
      default:
        this.router.navigateByUrl(`/${selected}`);
    }
  }
}
